export default class CrudModes {
  static get TYPES() {
    return {
      ADD: 'add',
      UPDATE: 'delete/update',
      READ: 'read'
    }
  }
}
